import { Component } from '@angular/core';
import * as moment from 'moment';
import { MyClass } from 'src/myclass';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'angularaddnewbooks2';
  mom = moment().format('LLLL');
  myclassinst = new MyClass('johannes');
}
